import React from 'react';
import { ResponsivePie } from '@nivo/pie';
import { generateGradientsAndColors, generateGradients, NivoTextTheme, applyGradients } from "./utils";

const NivoPieChart = ({
    data,
    customColors,
    radius = 0.7,
    legend = false,
    showLabels = true,
    size = null,
    translateX=-120,
    legendSpacing=20,
    translateY=0,
    legendSymbolSize=15,
    legendItemHeight=15,
    borderWidth=0,
    labelPostfix=''
}) => {
    const { gradients, colorMapping } = generateGradientsAndColors(data.map(d => d.id), customColors);

    const pieChartData = data.map(item => ({
        ...item,
        color: colorMapping[item.id]
    }));

    const isTiny = size === 'tiny';
    const keys = data.map(x => x.id);
    const baseColorMapping = d => colorMapping[d.id];

    const commonProperties = {
        margin: isTiny ? { top: 10, right: 10, bottom: 10, left: 10 } : { top: showLabels ? 20 : 0, right: 0, bottom: showLabels ? 20 : 0, left: legend ? 120 : 0 },
        innerRadius: isTiny ? 0 : radius,
        padAngle: isTiny ? 0 : 0.7,
        cornerRadius: isTiny ? 1 : 0,
        borderWidth,
        borderColor: { from: 'color', modifiers: [['darker', 0]] },
        colors: baseColorMapping,
        defs: generateGradients(keys, colorMapping),
        fill: applyGradients(keys),
        animate: true,
        motionConfig: "gentle",
    };

    const pieProps = isTiny ? {
        enableArcLinkLabels: false,
        enableArcLabels: false,
        legends: []
    } : {
        enableArcLinkLabels: showLabels,
        enableArcLabels: showLabels,
        arcLabelsTextColor: "#ffffff",
        arcLinkLabelsColor: baseColorMapping,
        arcLinkLabelsThickness: 0,
        arcLinkLabelsSkipAngle: 10,
        arcLinkLabelsTextColor: '#333333',
        arcLinkLabelsTextOffset: 0,
        arcLinkLabelsStraightLength: 0,
        arcLabelsSkipAngle: 30,
    };

    const legendConfig = legend ? [
        {
            anchor: 'top-left',
            direction: 'column',
            justify: false,
            translateX: translateX,
            translateY: translateY,
            itemsSpacing: legendSpacing,
            itemWidth: 100,
            itemHeight: legendItemHeight,
            itemDirection: 'left-to-right',
            symbolShape: 'circle',
            itemOpacity: 1,
            symbolSize: legendSymbolSize,
            effects: [
                {
                    on: 'hover',
                    style: {
                        itemOpacity: 1
                    }
                }
            ]

        }
    ] : [];

    return (
        <ResponsivePie
            data={pieChartData}
            theme={{ ...NivoTextTheme, legends: { text: { fontSize: 15, fontWeight: '500' } } }}
            {...commonProperties}
            {...pieProps}
            legends={legendConfig}
        />
    );
};

export default NivoPieChart;